import EmpresasInfoStore from './EmpresasInfoStore';
import EmpresasListStore from './EmpresasListStore';
import EmpresasUpsertStore from './EmpresasUpsertStore';
import EmpresaAsignacionHitsStore from './EmpresaAsignacionHitsStore';

const EmpresasStore = {
  list: EmpresasListStore,
  info: EmpresasInfoStore,
  upsert: EmpresasUpsertStore,
  hits: EmpresaAsignacionHitsStore,
};

export default EmpresasStore;
